/**
 * ACC Product Card — custom element + QuickAddComponent compatibility patches.
 *
 * Loaded as a module so the browser deduplicates it regardless of how many
 * sections reference it (collection grid, recommendations, flavor lineup, etc.).
 */

/* ── AccProductCard custom element ── */

class AccProductCard extends HTMLElement {
  getProductCardLink() {
    return this.querySelector('a.acc-product-card__media-link') || null;
  }

  getSelectedVariantId() {
    return null;
  }
}

if (!customElements.get('acc-product-card')) {
  customElements.define('acc-product-card', AccProductCard);
}

/* ── Patch QuickAddComponent.productPageUrl to also find acc-product-card ── */

customElements.whenDefined('quick-add-component').then(() => {
  const QuickAddComponent = customElements.get('quick-add-component');
  if (!QuickAddComponent) return;

  const originalDescriptor = Object.getOwnPropertyDescriptor(QuickAddComponent.prototype, 'productPageUrl');
  if (!originalDescriptor || !originalDescriptor.get) return;

  const originalGetter = originalDescriptor.get;

  Object.defineProperty(QuickAddComponent.prototype, 'productPageUrl', {
    get() {
      const accCard = this.closest('acc-product-card');
      if (accCard) {
        const productLink = accCard.getProductCardLink();
        if (!productLink?.href) return '';
        return new URL(productLink.href).toString();
      }
      return originalGetter.call(this);
    },
    configurable: true,
  });
});

/* ── Fix scroll-position race: quick-add dialog close vs cart drawer open ── */

const quickAddDialog = document.getElementById('quick-add-dialog');
if (quickAddDialog) {
  quickAddDialog.addEventListener('cart:update', () => {
    const dialog = quickAddDialog.querySelector('dialog');
    if (!dialog?.open) return;

    const scrollY = Math.abs(parseInt(document.body.style.top || '0', 10));

    document.body.style.width = '';
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo({ top: scrollY, behavior: 'instant' });

    dialog.close();
    dialog.classList.remove('dialog-closing');

    quickAddDialog.dispatchEvent(new CustomEvent('dialog:close'));
  }, { capture: true });
}
